<template>
  <v-row dense v-if="tab != 3">
    <v-col cols="12">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="auto" class="pl-12 pr-6 my-auto">
              <v-img max-width="220" :src="image" />
            </v-col>
            <v-col>
              <div class="text-h4 font-weight-bold pb-3">
                Meetings:
                <span :class="`${color}--text`">{{ title }}</span>
              </div>
              <div class="subtitle-1">
                {{ text }}
              </div>
              <div>
                <v-stepper v-model="step" class="transparent" v-if="started">
                  <v-stepper-header>
                    <v-stepper-step
                      :complete="step > 1"
                      step="1"
                      color="secondary"
                      class="subtitle-1 pl-0"
                    >
                      Talking Points
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step
                      :complete="step > 2"
                      step="2"
                      color="secondary"
                      class="subtitle-1"
                    >
                      Goals
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step
                      :complete="step > 3"
                      step="3"
                      color="secondary"
                      class="subtitle-1"
                    >
                      Action Items
                    </v-stepper-step>
                  </v-stepper-header>
                </v-stepper>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" v-if="!isComplete && tab != 3">
              <v-list flat color="background" dense class="rounded-lg">
                <v-list-item @click="showTalkingPointDialog" v-if="tab == 0">
                  <v-list-item-icon class="mr-2">
                    <v-icon color="performance">add_circle</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content class="subtitle-1">
                    Add a talking point
                  </v-list-item-content>
                </v-list-item>
                <v-list-item @click="showGoalDialog" v-if="tab == 1">
                  <v-list-item-icon class="mr-2">
                    <v-icon color="success">add_circle</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content class="subtitle-1">
                    Add a goal
                  </v-list-item-content>
                </v-list-item>
                <v-list-item @click="showActionItemDialog" v-if="tab == 2">
                  <v-list-item-icon class="mr-2">
                    <v-icon color="info">add_circle</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content class="subtitle-1">
                    Add action item
                  </v-list-item-content>
                </v-list-item>
                <edit-talking-point-dialog
                  ref="addTalkingPoint"
                ></edit-talking-point-dialog>
                <edit-goal-dialog ref="addGoal"></edit-goal-dialog>
                <edit-action-item-dialog
                  ref="addActionItem"
                ></edit-action-item-dialog>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import EditTalkingPointDialog from "@/components/checkin/EditTalkingPointDialog";
import EditGoalDialog from "@/components/goals/EditGoalDialog";
import EditActionItemDialog from "@/components/checkin/EditActionItemDialog";
export default {
  name: "CheckInHeaderCard",
  components: { EditTalkingPointDialog, EditGoalDialog, EditActionItemDialog },
  props: {},
  computed: {
    step() {
      return this.tab + 1;
    },
    title() {
      switch (this.tab) {
        case 0:
          return "Talking Points";
        case 1:
          return "Goals";
        case 2:
          return "Action Items";
        case 3:
          return "Finish";
        default:
          return "";
      }
    },
    image() {
      switch (this.tab) {
        case 0:
          return this.$images.CHECKIN_TALKINGPOINTS;
        case 1:
          return this.$images.CHECKIN_GOAL;
        case 2:
          return this.$images.CHECKIN_ACTIONITEMS;
        default:
          return "";
      }
    },
    text() {
      switch (this.tab) {
        case 0:
          return this.started
            ? "First up in this meeting are talking points. Use talking points to be more organized and productive during your meeting. They're a great starting point!"
            : `Use talking points to be more organized and productive during your meeting. They're a great starting point and we'll even suggest some for you!`;
        case 1:
          return "Use the Goal section to review any existing goals, create new goals or simply skip it if it's not relevant to your meeting.";
        case 2:
          return "Let's give action to this meeting to keep things moving along. We'll pull any new or outstanding action items into this list, but you can also create more.";
        default:
          return "";
      }
    },
    color() {
      switch (this.tab) {
        case 0:
          return "performance";
        case 1:
          return "success";
        case 2:
          return "info";
        default:
          return "";
      }
    },
    started() {
      return this.checkin.startDate != null;
    },
    isComplete() {
      return this.checkin.completeDate != null;
    },
    ...mapGetters({
      checkin: "checkin/checkin",
      profile: "profile/profile",
      tab: "checkin/tab"
    })
  },
  methods: {
    showTalkingPointDialog() {
      this.$refs.addTalkingPoint.showDialog({});
    },
    showGoalDialog() {
      this.$refs.addGoal.showDialog(
        {
          user: { id: this.checkin.userIdFor1on1 },
          checkInDefinitionId: this.checkin.definitionId
        },
        this.checkin.userIdFor1on1 ? [] : this.checkin.attendees
      );
    },
    showActionItemDialog() {
      this.$refs.addActionItem.showDialog({});
    }
  }
};
</script>

<style lang="scss" scoped>
.v-stepper__step:not(.v-stepper__step--inactive) {
  ::v-deep .v-stepper__label {
    color: var(--v-secondary-base) !important;
  }
}

.v-stepper__header {
  hr {
    border-top-style: dashed;
  }
}
</style>
